/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState, useRef } from 'react';
import {
	Hidden
} from '@material-ui/core';
import DateRangeSelector from '../../../DateRangeSelector';
import ProductAttributesFilter from './productAttributes/defaultPAFilter';
import ProductAttributesFilterModal from './productAttributes/defaultPAModal';
import Sort from '../sort/Sort';

import '../../../../css/filter.css';

export default function DefaultFilter(props) {
	const {
		callback,
		currency,
		customAttributeMap,
		displayAttribute,
		enableFilter,
		filter,
		filterAttributes,
		filterValues,
		handleFilterClick,
		handleFilterChange,
		handleFilterNumericChange,
		marketplaceType,
		pageActiveCallback,
		productAttributes,
		resetFilter,
		searchParams,
		searchComponents,
		setCustomAttributeMap,
		showTriggerButton,
		sortCb,
		mobileModalVisible,
		setMobileModalVisibility,
		width
	} = props;
	const filterStandardAttributes = productAttributes
    && productAttributes.standardAttributes.filter((element) => element.isFiltered);
	const textRef = useRef();
	const [displayFilters, setDisplayFilters] = useState(productAttributes && filterStandardAttributes
        && filterStandardAttributes.concat(productAttributes.customAttributes));
	const [widthWindow, setWidthWindow] = useState(window.innerWidth);
	const [allFilters, setAllFilters] = useState(null);
	const [allButtonsWidth, setAllButtonsWidth] = useState(null);

	useEffect(() => {
		const filtersToSet = textRef.current;
		setAllFilters(filtersToSet);
		if (filtersToSet) {
			const filtersToSetArr = [];
			filtersToSet.childNodes.forEach((filter) => filtersToSetArr.push(filter.offsetWidth));
			setAllButtonsWidth(
				filtersToSetArr
			);
		}
	}, []);

	useEffect(() => {
		function handleResize() {
			setWidthWindow(window.innerWidth);
		}
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, [widthWindow]);

	useEffect(() => {
		if (allFilters) {
			let totalWidth = 0;
			const arrayFilters = [];
			const filters = allFilters;
			const filterCustomAttributes = productAttributes
            && productAttributes.customAttributes.filter((element) => element.isFiltered);
			const displayFiltersToShow = filterStandardAttributes
                && filterStandardAttributes.concat(filterCustomAttributes);
			const finalFilters = displayFiltersToShow && displayFiltersToShow.filter((attribute) => {
				const {
					uniqueName, name, pickListElements
				} = attribute;
				return uniqueName !== 'location'
                && !(name === 'Category' && pickListElements && !pickListElements.length);
			});
			filters.childNodes.forEach((filter, index) => {
				// eslint-disable-next-line no-unused-expressions
				width === 'sm'
					? totalWidth += (index === 0 ? 130 : allButtonsWidth[index - 1] + 10)
					: totalWidth += allButtonsWidth[index] + 10;
				if (totalWidth > widthWindow - 370) {
					filter.style.display = 'none';
					if(finalFilters)
						arrayFilters.push(width === 'sm' ? finalFilters[(++index) - 1] : finalFilters[index]);
				} else {
					filter.style.display = 'inline-block';
				}
			});
			setDisplayFilters(arrayFilters);
		}
	}, [widthWindow, allFilters]);

	return (
		<>
			{width !== 'xs'
				? (
					<div id="filterContents" ref={textRef}>
						<Hidden mdUp>
							<div className="col-xs-12">
								<DateRangeSelector
									callback={callback}
									pageActiveCallback={pageActiveCallback}
									searchParams={searchParams}
									showTriggerButton={showTriggerButton}
									searchComponents={searchComponents}
								/>
							</div>
						</Hidden>
						<ProductAttributesFilter
							currency={currency}
							customAttributeMap={customAttributeMap}
							displayAttribute={displayAttribute}
							filterAttributes={filterAttributes}
							filterValues={filterValues}
							handleFilterClick={handleFilterClick}
							allButtonsWidth={allButtonsWidth}
							marketplaceType={marketplaceType}
							productAttributes={
								{
									standardAttributes: filterStandardAttributes,
									customAttributes: productAttributes && productAttributes.customAttributes
								}
							}
							setCustomAttributeMap={setCustomAttributeMap}
						/>
					</div>
				)
				: null}
			{window.location.pathname === '/' || window.location.pathname === '/search'
				? (
					<ProductAttributesFilterModal
						productAttributes={
							{
								standardAttributes: filterStandardAttributes,
								customAttributes: productAttributes && productAttributes.customAttributes
							}
						}
						setCustomAttributeMap={setCustomAttributeMap}
						displayFilters={displayFilters}
						filter={filter}
						handleFilterChange={handleFilterChange}
						handleFilterNumericChange={handleFilterNumericChange}
						enableFilter={enableFilter}
						resetFilter={resetFilter}
						width={width}
						displayAttribute={displayAttribute}
						filterAttributes={filterAttributes}
						filterValues={filterValues}
						sortCb={sortCb}
						mobileModalVisible={mobileModalVisible}
						setMobileModalVisibility={setMobileModalVisibility}
						{...props}
					/>
				)
				: null}
			{width !== 'xs'
				? (
					<div style={{ marginLeft: 'auto' }}>
						<Sort {...props} />
					</div>
				)
				: null}
		</>
	);
}
